import { Col, Row } from 'antd';

const PackageSummaryWidgetContainer = ({
  children,
  className,
}: {
  children: React.ReactNode[];
  className?: string;
}) => {
  const [packageCountWidget, signedInvoicesWidget, stuckPackagesWidget] =
    children;

  return (
    <Row
      gutter={[16, 16]}
      className={`package-summary-container ${className || ''}`}
    >
      <Col xs={24} lg={16} className="left-column">
        {packageCountWidget}
      </Col>
      <Col xs={24} lg={8} className="right-column">
        <Row gutter={[0, 10]}>
          <Col span={24}>{signedInvoicesWidget}</Col>
          <Col span={24}>{stuckPackagesWidget}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PackageSummaryWidgetContainer;
